module.exports = __webpack_public_path__ + "img/dy1.9245461b.png";